// @index: export * from ${relpath}
export * from './paths'
export * from './resources'
export * from './types'
// /index